<template>
	<button :class="[`additional-options`, `project-actions`]" v-if="showEdits || showArchive || showUnarchive || showPromote || showDelete" @click="toggleActions">
		<img class="project-actions" :src="require('@/drc/assets/icons/3dots.svg')" alt="...">
		<div class="additional-option-popup project-actions" v-if="openAdditionalOptions">
			<div class="option-button option-button-edit project-actions" v-if="showEdits" @click="edit">
				<img class="project-actions" src="@/common/assets/icons/edit-blue-2.svg" alt="edit">
				{{$t('controlPanel.landingPage.buttons.edit')}}
			</div>
			<div class="option-button option-button-archive project-actions" v-if="showArchive" @click="archive">
				<img class="project-actions" src="@/common/assets/icons/archive-blue.svg" alt="share">
				{{$t('controlPanel.landingPage.buttons.archive')}}
			</div>
			<div class="option-button option-button-unarchive project-actions" v-if="showUnarchive" @click="unarchive">
				<img class="project-actions" src="@/common/assets/icons/unarchive.svg" alt="unarchive">
				{{$t('controlPanel.landingPage.buttons.unarchive')}}
			</div>
			<div class="option-button option-button-promote project-actions" v-if="showPromote" @click="promote">
				<img class="project-actions" src="@/common/assets/icons/promote.svg" alt="promote">
				{{$t('controlPanel.landingPage.buttons.promote')}}
			</div>
			<div class="option-button option-button-delete project-actions" v-if="showDelete" @click="deleteProject">
				<img class="project-actions" src="@/common/assets/icons/delete-red-2.svg" alt="delete">
				{{$t('controlPanel.landingPage.buttons.delete')}}
			</div>
		</div>
	</button>
</template>

<script>
import {NOTIFICATION_TYPE, PERMISSIONS} from "@/common/utils/constants";
import {EventButton} from "@/common/configurations/event-bus";
import * as PROJECT_SERVICE from "@/drc/services/drc-request-service";
import {promoteProject} from "@/drc/services/drc-request-service";

export default {
	name: "CardProjectActions",
	props: {
		project: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			openAdditionalOptions: false,
		}
	},
	created() {
		document.addEventListener("click", this.closeDropdown);
		EventButton.$on('close-project-dropdown', this.closeDropdown);
	},
	destroyed() {
		document.removeEventListener("click", this.closeDropdown);
		EventButton.$off('close-project-dropdown');
	},
	computed: {
		showEdits() {
			return this.$route.name === 'my-stories-drafts'
		},
		showArchive() {
			return this.$route.name === 'my-stories-drafts'
		},
		showUnarchive() {
			return this.$route.name === 'my-stories-archived'
		},
		showPromote() {
			let promotedProjects = this.$store.getters.getPromoteOption('promotedProjects').map(promotion => promotion.project.id);
			return this.$route.name === 'my-stories-shared' && this.$store.getters.isPromotionApplicable && !promotedProjects.includes(this.project.id);
		},
		showDelete() {
			return this.$route.name === 'my-stories-archived'
				&& (this.project.currentProjectStep === 'DRAFT' || this.hasPermission(PERMISSIONS.additionalCmtAccess))
		}
	},
	methods: {
		closeDropdown(event) {
			if ((event?.target && !event.target.classList.contains('project-actions')) || !event) {
				this.openAdditionalOptions = false;
			}
		},
		toggleActions() {
			let isOpened = this.openAdditionalOptions;
			EventButton.$emit('close-project-dropdown')
			this.openAdditionalOptions = !this.openAdditionalOptions
			if (isOpened === this.openAdditionalOptions) {
				this.closeDropdown()
			}
		},
		edit() {
			this.$router.push({name: 'submission-continue-draft-project', params: {id: this.project.id}});
		},
		archive() {
			this.$dialog.openPopupModal({
				text: `${this.$t('common.areYouSureYouWantToArchiveProject')}`,
				onConfirm: () => {
					PROJECT_SERVICE.archive(this.project.id)
						.then(() => {
							this.$emit('hideProject', this.project);
							this.showNotification(this.$t('notifications.successArchived'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((err) => {
							console.error("err:", err);
							this.showNotification(this.$t('notifications.error'), NOTIFICATION_TYPE.ERROR);
						})
				}
			})
		},
		unarchive() {
			this.$dialog.openPopupModal({
				text: `${this.$t('common.areYouSureYouWantToUnarchiveProject')}`,
				onConfirm: () => {
					PROJECT_SERVICE.unarchive(this.project.id)
						.then(() => {
							this.$emit('hideProject', this.project);
							this.showNotification(this.$t('notifications.successUnarchived'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((err) => {
							console.error("err:", err);
							this.showNotification(this.$t('notifications.error'), NOTIFICATION_TYPE.ERROR);
						})
				}
			})
		},
		promote() {
			this.$loader.show({text: '', description: '', buttonText: null, isBlue: false, onCancel: () => {}});
			let option = this.$store.getters.getValidPromoteOption;
			promoteProject(this.project.id, option.optionType, option.applicableIds)
				.then((response) => {
					if (response.errors?.length > 0) {
						console.error(response.errors);
						this.showNotification(this.$t('notifications.error'), NOTIFICATION_TYPE.ERROR);
						this.$loader.hide();
					} else {
						this.$dialog.openPopupModal({
							title: `${this.$t('notifications.success')}`,
							positiveButtonText: `${this.$t('buttons.confirm')}`,
							hideCancel: true,
							text: `${this.$t('notifications.acceptedPromotion')}`,
							onConfirm: () => {
								this.showNotification(this.$t('notifications.successPromoted'), NOTIFICATION_TYPE.SUCCESS);
								EventButton.$emit('promoteProjectAction');
							}
						})
					}
				})
		},
		deleteProject() {
			this.$dialog.openPopupModal({
				text: `${this.$t('common.areYouSureYouWantToDeleteProject')}`,
				onConfirm: () => {
					PROJECT_SERVICE.deleteArchivedDraft(this.project.id)
						.then(() => {
							this.$emit('hideProject', this.project);
							this.showNotification(this.$t('notifications.successDeleted'), NOTIFICATION_TYPE.SUCCESS);
						})
						.catch((err) => {
							console.error("err:", err);
							this.showNotification(this.$t('notifications.error'), NOTIFICATION_TYPE.ERROR);
						})
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.additional-options {
	position: absolute;
	top: 16px;
	right: 16px;
	background: #FFFFFF;
	border: 1px solid #E5E5EA;
	width: 32px;
	height: 32px;
	border-radius: 4px;
	cursor: pointer;
	color: #001f33;
	z-index: 3;

	.additional-option-popup {
		position: absolute;
		top: 40px;
		right: -10px;
		background: white;
		border-radius: 4px;
		box-shadow: 0px 25px 21px -5px #0000001A;
		box-shadow: 0px 2px 25px -5px #00000029;
		z-index: 4;
		display: flex;
		flex-direction: column;
		gap: 5px;
		border: 1px solid #E5E5EA;

		.option-button {
			padding: 8px 12px;
			width: 145px;
			height: 40px;
			cursor: pointer;
			color: #001f33;
			font-family: Roboto, serif;
			font-weight: 400;
			font-size: 15px;
			line-height: 20px;
			letter-spacing: 0px;
			text-align: left;
			display: flex;
			align-items: center;

			img {
				margin-right: 12px;
			}

			&:hover {
				background-color: #F2F2F2;
			}

			&.option-button-delete {
				color:#FF3B30;
			}
		}

	}
}
</style>
